import { Helmet } from "react-helmet";
import graph from "../images/Section-3/tab.png"; // use your correct image path

export default function SectionThree({ openModal }: any) {
  return (
    <div className="bg-white min-h-screen flex flex-col gap-4 items-center justify-center px-4 py-4 font-poppins relative">
      <Helmet>
        <title>Discover Digital Growth | Student Acquisition Program</title>
        <meta
          name="description"
          content="Find out how you can grow your student acquisition with our digital audit."
        />
        <meta
          name="keywords"
          content="student acquisition, digital marketing, online growth"
        />
        <meta property="og:title" content="Student Acquisition Program" />
        <meta
          property="og:description"
          content="Get a digital audit and discover ways to improve student enrollment."
        />
        <meta property="og:type" content="website" />
      </Helmet>

      <div className="max-w-7xl md:rounded-[62px] rounded-[40px] font-poppins bg-[#DFF5F7] mx-auto px-2 sm:px-2 lg:px-4 py-10 space-y-10 flex flex-col items-center justify-center">
         {/* Heading Section */}
         <div className="text-center space-y-2">
          <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-blue-600">
            Dial Up Your Digital
          </h1>
          <h2 className="text-lg sm:text-xl md:text-2xl font-semibold text-gray-800">
            Complete Marketing
          </h2>
          <p className="text-sm sm:text-base text-gray-600 max-w-xl mx-auto">
            Lead Generated, Lead Nurtured, Opportunity Maximized
          </p>
        </div>
        {/* Graph Image */}
        <div className="w-full flex justify-center">
          <img
            src={graph}
            alt="Digital Marketing Flow"
            className="w-full max-w-2xl sm:max-w-3xl lg:max-w-4xl object-contain"
          />
        </div>

        
      </div>
      {/* Bottom Button */}
      <div className="w-full flex items-center justify-center">
          <button
            onClick={openModal}
            className="bg-[#E91212] text-white px-6 py-2 md:px-8 md:py-3 rounded-xl font-bold text-sm md:text-xl hover:bg-[#e34242] transition-transform duration-300 transform hover:scale-105"
          >
            Know More
          </button>
        </div>
    </div>
  );
}
